module.exports = __webpack_public_path__ + "static/media/enteromarpng.56af2746.png";